export default function About() {
  return (
    <div className="card-container">
      <div className="card-body" style={{ lineHeight: "2" }}>
        <h3 className="card-title" style={{ fontSize: "22px" }}>
          एशिया रग्बी अंडर-20 सेवेन्स चैंपियनशिप 2025
        </h3>

        <p className="card-text">
          बिहार के इतिहास में एक स्वर्णिम पृष्ठ जुड़ने जा रहा है! पहली बार
          प्राचीन नगरी राजगीर में एशिया रग्बी अंडर-20 सेवेन्स चैंपियनशिप 2025 का
          भव्य आयोजन 9 और 10 अगस्त को होगा। यह टूर्नामेंट न केवल बिहार की खेल
          संस्कृति को वैश्विक पटल पर ले जाएगा, बल्कि एशिया के रग्बी जगत में एक
          नया कीर्तिमान स्थापित करेगा। इसमें 8 पुरुष और 8 महिला टीमें हिस्सा
          लेंगी, जिनमें भारत, हांगकांग, चीन, संयुक्त अरब अमीरात, उज्बेकिस्तान,
          कजाकिस्तान, श्रीलंका, मलेशिया (केवल पुरुष) और नेपाल (केवल महिला) जैसे
          शीर्ष एशियाई देश शामिल हैं। 7 अगस्त से सभी टीमें राजगीर पहुंचेंगी,
          जहां बिहार की आतिथ्य परंपरा का अनुभव करेंगी। 8 अगस्त को राजगीर खेल
          परिसर के कबड्डी हॉल में आयोजित भव्य उद्घाटन समारोह इस आयोजन की शान
          बढ़ाएगा। सभी टीमें राजगीर में ही ठहरेंगी, जिससे स्थानीय संस्कृति और
          रग्बी का अनूठा संगम देखने को मिलेगा। एशिया के 32 रग्बी खेलने वाले
          देशों में से केवल शीर्ष 8 रैंकिंग वाली टीमें ही इस प्रतिष्ठित
          चैंपियनशिप में भाग लेती हैं, जो इसकी महत्ता को रेखांकित करता है। बिहार
          के लिए यह आयोजन गर्व का विषय है, क्योंकि रग्बी राज्य की 14 प्राथमिकता
          वाले खेलों में शामिल है। भारतीय रग्बी टीम में बिहार के खिलाड़ी भी अपनी
          प्रतिभा का लोहा मनवाएंगे। हाल ही में नेशनल गेम्स में बिहार की महिला
          टीम ने रजत पदक जीता, जबकि स्कूल गेम्स में बालक और बालिका टीमों ने
          जूनियर, सब-जूनियर और सीनियर वर्गों में चैंपियनशिप हासिल कर रग्बी में
          बिहार का परचम लहराया। यह चैंपियनशिप बिहार के उभरते खिलाड़ियों को
          वैश्विक मंच प्रदान करेगी और रग्बी के प्रति युवाओं में उत्साह जगाएगी।
          राजगीर में होने वाला यह आयोजन बिहार की खेल यात्रा में एक मील का पत्थर
          साबित होगा, जो विश्व भर में राज्य की पहचान को नई ऊंचाइयों पर ले जाएगा।
        </p>
        <br />
      </div>
    </div>
  );
}
